import StimulusTomSelect from "stimulus-tom-select";

// サーバ側インクリメンタル検索つきの顧客セレクタ（tom-select）。
// 顧客が大量（数千〜数万）でも全件をプリロードせず、入力に応じて候補を取得する。
//
// 使い方:
//   <%= f.select :customer_id, options, { include_blank: ... },
//         data: { controller: "customer-search",
//                 "customer-search-url-value": admin_customers_path(format: :json) } %>
//
// エンドポイントは ?keyword=<入力> で [{ value, text }] の配列を返す想定。
export class CustomerSearchController extends StimulusTomSelect {
  static values = { url: String, options: Object };

  initTomSelect() {
    this.options = {
      valueField: "value",
      labelField: "text",
      searchField: ["text"],
      allowEmptyOption: true, // 「すべての顧客」（空欄）に戻せるようにする
      loadThrottle: 300, // 入力ごとの過剰リクエストを抑制
      load: (query, callback) => {
        if (query.length < 1) return callback();

        const url = `${this.urlValue}?keyword=${encodeURIComponent(query)}`;
        fetch(url, { headers: { Accept: "application/json" } })
          .then((response) => response.json())
          .then((json) => callback(json))
          .catch(() => callback());
      },
      ...this.optionsValue,
    };
    super.initTomSelect();
  }
}
